import React from 'react'
// import Header from '../../components/header/Header'
// import Navbar from '../../components/navbar/Navbar'
// import Footer from '../../components/footer/Footer'
import AcademySiderbar from './AcademySiderbar'
import { ToastContainer } from 'react-toastify'
import { Navigate, Route, Routes } from 'react-router-dom'
import AcademyProduct from './AcademyProduct'
import AcademyArchitecture from './AcademyArchitecture'
import AcademyProductDetail from './AcademyProductDetail'
import { Outlet } from 'react-router-dom';
import AcademyBlogs from './AcademyBlogs'
import AcademyBlogDetail from './AcademyBlogDetail'
import AcademyEvents from './AcademyEvents'
import AcademyEventsDetail from './AcademyEventsDetail'


const Academy: React.FC = () => {
  return (
    <div className=''>
        <Outlet />
        {/* <Header />
        <Navbar /> */}
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={true} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover/>

        <div className=' flex min-h-[900px] p-3'>
            <div className=' flex-1'>
                <AcademySiderbar className="w-[72px] md:w-[240px] h-[calc(100vh-164px)]"/>
            </div>

            <div className=' flex-[8]'>
                <Routes>
                        <Route path="/" element={<Navigate to="/academy/academy/product" />} />
                        <Route path="academy/product" element={<AcademyProduct/>}/>
                        <Route path="product-detail/:id" element={<AcademyProductDetail/>}/>
                        <Route path="academy/blog" element={<AcademyBlogs/>}/>
                        <Route path="blog-detail/:id" element={<AcademyBlogDetail/>}/>
                        <Route path="academy/events" element={<AcademyEvents/>}/>
                        <Route path="academy/architecture" element={<AcademyArchitecture/>}/>
                        <Route path="events-detail/:id" element={<AcademyEventsDetail/>}/>
                </Routes>
            </div>
        </div>

        {/* <Footer /> */}
    </div>
  )
}

export default Academy